import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

$('.slider_c739').each(function(){
  var $slider = $(this);
  var $slides = $slider.find('.slider_c739__slides');
  var $prev = $slider.find('.slider_c739__prev');
  var $next = $slider.find('.slider_c739__next');

  new Swiper($slides[0], {
    // slidesPerView: 'auto',
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    // },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      540: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1180: {
        slidesPerView: 3,
      }
    },
    // Navigation arrows
    navigation: {
      nextEl: $next[0],
      prevEl: $prev[0],
    }
  });

});
